import commonMixins from '@/mixins/templates/common';

export default {
  mixins: [commonMixins]
};
